import React, { useState, useRef, useEffect } from 'react';
export function VideoPlayer({
  src,
  className = ''
}: {
  src: string;
  className?: string;
}) {
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, {
      threshold: 0.2
    });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };
  return <div className={`relative w-full overflow-hidden ring-1 ring-white/15 bg-black group ${className}`} data-id="element-225" data-mp="2wod5k07u1919">
      <video ref={videoRef} src={src} playsInline muted loop className="h-full w-full object-cover" poster={`${src}#t=0.1`} data-id="element-226" data-mp="2rp1k4dwitfdc" />
    </div>;
}